import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

export interface RegisterLeadPayload {
  email: string;
  name?: string;
  phone?: string;
  source?: string;
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  utmTerm?: string;
  utmContent?: string;
}

@Injectable({
  providedIn: 'root',
})
export class RegisterLeadService {
  private httpClient = inject(HttpClient);

  registerLead(payload: RegisterLeadPayload) {
    return this.httpClient.post('/api/customers/leads', payload);
  }
}
